import React, { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '@ui';
import { EditGenericEventModalContext } from '../../context/EditGenericEventModalContext';
import { translate } from '@utils/i18n';
function Footer() {
    const namespace = 'features.modals.edit_generic_event_modal.footer';
    const { getValues, reset, formState: { defaultValues } } = useFormContext();
    const { handleModalSave } = useContext(EditGenericEventModalContext);
    const onSave = () => {
        handleModalSave({
            genericEvent: getValues(),
            updateFutureEvents: true,
            originalStart: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.start
        });
        reset(getValues());
    };
    const onCancel = () => {
        reset(getValues());
    };
    return (React.createElement("div", { className: "footer" },
        React.createElement("div", { className: "footer__wrapper" },
            React.createElement("span", null, translate('description', { namespace })),
            React.createElement("div", { className: "control-buttons" },
                React.createElement(Button, { variant: "secondary", onClick: onCancel }, translate('no', { namespace: 'generic' })),
                React.createElement(Button, { variant: "secondary", onClick: onSave }, translate('yes', { namespace: 'generic' }))))));
}
export default Footer;
